import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { toast } from 'react-toastify';
import ImageModalEquip from '../Modal/ImageModalProd';
import { decryptToken } from '../utils/getToken';


const SliderModal = ({ isOpen, setIsOpen, data, setData, sliderFetch }) => {
    const url = API_BASE_URL;
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [productOptions, setProductOptions] = useState([]);
    const [showImageModal, setShowImageModal] = useState(false);
    const [showBackgroundModal, setShowBackgroundModal] = useState(false);
    const [images, setImages] = useState([]);
    const [error, setError] = useState(false);
    const token = decryptToken("accessToken") || ""
    const [sliderType, setSliderType] = useState(data.slider_type || "image");
    const [load, setLoad] = useState(false);

    const handleSliderTypeChange = (e) => {
        const value = e.target.value;
        setSliderType(value);
        setData({ ...data, slider_type: value });
    };

    const fetchImages = async () => {
        try {
            const res = await fetch(`${url}/api/images/${isLoggedIn.main_id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const data = await res.json();
            setImages(data);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchImages();
    }, []);

    const fetchProducts = async () => {
        try {
            const response = await fetch(`${url}/grouped-product/search-all-products/${isLoggedIn.main_id}?includeInactive=true`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            const res = await response.json();

            const options = res.map((product) => ({
                value: product.product_id,     // or product.id
                label: product.title,
                ...product              // 👈 include all product fields here
            }));

            setProductOptions(options);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);


    const handleChange = (e) => {
        const { name, value } = e.target;
        let updatedData = { ...data, [name]: value };

        if (name === "link" && value.trim() !== "") {
            updatedData.product = null; // Clear linked product if link is filled
        }

        // Price validation logic (keep your existing one)
        // if (name === "price" || name === "cutOffPrice") {
        //     const cutOff = parseFloat(updatedData.cutOffPrice);
        //     const price = parseFloat(updatedData.price);
        //     setError(!isNaN(price) && !isNaN(cutOff) && price > cutOff);
        // }

        setData(updatedData);
    };


    const handleProductSelect = (selectedOption) => {
        const fullProduct = productOptions.find(p => p.value === selectedOption?.value);

        // If a product is selected, clear the link
        if (selectedOption) {
            setData({ ...data, product: fullProduct, link: "" });
        } else {
            // If cleared
            setData({ ...data, product: null });
        }
    };


    const handleImageSelect = (field, img) => {
        setData((prev) => ({ ...prev, [field]: `${url}${img.url}` }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const requiredFields = [

            "image",

        ];

        const allEmpty = requiredFields.every(
            (field) => !data[field] || data[field].toString().trim() === ""
        );



        if (allEmpty) {
            toast.error("Please fill at least one details.");
            return;
        }

        if (data.cutOffPrice !== "" && data.price === "") {
            toast.error("Enter discounted price")
            return;
        }

        if (parseFloat(data.price) > parseFloat(data.cutOffPrice)) {
            toast.error("Discounted price should be less than Original Price")
            return;
        }

        const payload = {
            ...data,
            user_id: isLoggedIn.main_id,
            user_name: isLoggedIn.full_name,
        };
        setLoad(true);
        try {
            const response = await fetch(`${url}/slider${data.id ? `/${data.id}` : ""}`, {
                method: data.id ? "PUT" : "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            const res = await response.json();
            if (response.ok) {
                toast.success("Slider saved successfully");
                sliderFetch();
                setIsOpen(false);
            } else {
                toast.error("Failed to save slider");
            }
        } catch (error) {
            console.error(error)
        } finally{
            setLoad(false);
        }

    };


    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                <h2 className="oms-modal-title">Slider</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>



                    {sliderType === "image" && (
                        <>
                            {/* Desktop Image */}
                            <div className="oms-form-group ome-form-button2">
                                <label className="oms-form-label">Desktop Image (Size: 1920px*490px)</label>
                                <button type="button" onClick={() => setShowImageModal(true)}>
                                    Upload Desktop Image
                                </button>
                                {data.image && (
                                    <img src={data.image} alt="Desktop" style={{ width: 80, marginTop: 10 }} />
                                )}
                            </div>

                            {/* Mobile Image */}
                            <div className="oms-form-group ome-form-button2">
                                <label className="oms-form-label">Mobile Image (Size: 1200px*675px)</label>
                                <button type="button" onClick={() => setShowBackgroundModal(true)}>
                                    Upload Mobile Image
                                </button>
                                {data.mobile_image && (
                                    <img src={data.mobile_image} alt="Mobile" style={{ width: 80, marginTop: 10 }} />
                                )}
                            </div>

                            <ImageModalEquip
                                show={showImageModal}
                                handleClose={() => setShowImageModal(false)}
                                images={images}
                                onImageSelect={(img) => handleImageSelect('image', img)}
                                multiple={false}
                                setImages={setImages}
                            />

                            <ImageModalEquip
                                show={showBackgroundModal}
                                handleClose={() => setShowBackgroundModal(false)}
                                images={images}
                                onImageSelect={(img) => handleImageSelect('mobile_image', img)}
                                multiple={false}
                                setImages={setImages}
                            />
                            {/* Linked Product Selector */}
                            {!data.link && (
                                <div className="oms-form-group">
                                    <label htmlFor="product" className="oms-form-label">Linked Product</label>
                                    <Select
                                        options={productOptions}
                                        value={data.product}
                                        onChange={handleProductSelect}
                                        placeholder="Search and select a product to link"
                                        isClearable
                                    />
                                </div>
                            )}

                            {/* Redirection Link (only visible if product not selected) */}
                            {!data.product?.title && (
                                <div className="oms-form-group">
                                    <label htmlFor="link" className="oms-form-label">Link</label>
                                    <input
                                        type="text"
                                        id="link"
                                        name="link"
                                        value={data.link}
                                        onChange={handleChange}
                                        placeholder="Enter redirection link"
                                    />
                                </div>
                            )}

                        </>
                    )}

                    {sliderType === "content" && (
                        <>
                            {/* Slider Title */}
                            <div className="oms-form-group">
                                <label htmlFor="slider_name" className="oms-form-label">Slider Title</label>
                                <input
                                    type="text"
                                    id="slider_name"
                                    name="slider_name"
                                    value={data.slider_name}
                                    onChange={handleChange}
                                    placeholder="e.g. Mega Summer Sale"
                                />
                            </div>

                            {/* Description */}
                            <div className="oms-form-group">
                                <label htmlFor="description" className="oms-form-label">Slider Description</label>
                                <input
                                    type="text"
                                    id="description"
                                    name="description"
                                    value={data.description}
                                    onChange={handleChange}
                                    placeholder="Short description for the slider"
                                />
                            </div>

                            {/* Original Price */}
                            <div className="oms-form-group">
                                <label htmlFor="cutOffPrice" className="oms-form-label">Original Price</label>
                                <input
                                    type="number"
                                    id="cutOffPrice"
                                    name="cutOffPrice"
                                    value={data.cutOffPrice}
                                    onChange={handleChange}
                                    placeholder="e.g. 1999"
                                />
                            </div>

                            {/* Discounted Price */}
                            <div className="oms-form-group">
                                <label htmlFor="price" className="oms-form-label">Discounted Price</label>
                                <input
                                    type="number"
                                    id="price"
                                    name="price"
                                    value={data.price}
                                    onChange={handleChange}
                                    placeholder="e.g. 1499"
                                />
                                {
                                    error ? <p className='checkpricegreaterthan-slidermodal'>Discounted price should be less than Original Price</p> :
                                        null
                                }
                            </div>


                            {/* Offer Tagline */}
                            <div className="oms-form-group">
                                <label htmlFor="offer_name" className="oms-form-label">Offer Tagline</label>
                                <input
                                    type="text"
                                    id="offer_name"
                                    name="offer_name"
                                    value={data.offer_name}
                                    onChange={handleChange}
                                    placeholder="e.g. 25% Off – Limited Time!"
                                />
                            </div>

                            {/* Banner Image Upload */}
                            <div className="oms-form-group ome-form-button2">
                                <label htmlFor="image" className="oms-form-label">Main Image</label>
                                <button type="button" onClick={() => setShowImageModal(true)}>Upload Main Image</button>
                                <div>
                                    {data.image && (
                                        <img src={data.image} alt="Selected" style={{ width: 80, marginTop: 10 }} />
                                    )}
                                </div>
                            </div>

                            {/* Background Image Selection */}
                            <div className="oms-form-group ome-form-button2">
                                <label htmlFor="background_image" className="oms-form-label">Slider Background</label>
                                <button type="button" onClick={() => setShowBackgroundModal(true)}>Select Background</button>
                                <div>
                                    {data.background_image && (
                                        <img src={data.background_image} alt="Selected" style={{ width: 80, marginTop: 10 }} />
                                    )}
                                </div>
                            </div>

                            {/* Product Selection */}
                            <div className="oms-form-group">
                                <label htmlFor="product" className="oms-form-label">Linked Product</label>
                                <Select
                                    options={productOptions}
                                    value={data.product}
                                    onChange={handleProductSelect}
                                    placeholder="Search and select a product to link"
                                    isClearable
                                />
                            </div>

                            {/* Image Modals */}
                            <ImageModalEquip
                                show={showImageModal}
                                handleClose={() => setShowImageModal(false)}
                                images={images}
                                onImageSelect={(img) => handleImageSelect('image', img)}
                                multiple={false}
                                setImages={setImages}
                            />

                            <ImageModalEquip
                                show={showBackgroundModal}
                                handleClose={() => setShowBackgroundModal(false)}
                                images={images}
                                onImageSelect={(img) => handleImageSelect('background_image', img)}
                                multiple={false}
                                setImages={setImages}
                            />

                        </>
                    )}

                    {/* Form Actions */}
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
                        {
                            load ?<button type="button">Submiting...</button>:
                            <button type="submit">Submit</button>
                        }
                        
                    </div>
                </form>
            </div>
        </div>

    );
};


export default SliderModal;
